module.exports = __webpack_public_path__ + "static/media/super-hit.c1c9a1ce.png";